module.exports = "/assets/data/44c5597d0d21ce5062e0c58e1f87ac9e-SS6.data.json";